import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  MessagePayload,
  Messaging,
  onMessage,
  deleteToken,
} from "firebase/messaging";
import { getApps } from "firebase/app";

export const initialApp = (firebaseConfig: Record<string, string>) => {
  const app = initializeApp(firebaseConfig);

  return getMessaging(app);
};

export const getAppToken = (
  messaging: Messaging,
  callback: (token: string) => void,
  VAPID: string,
) => {
  getToken(messaging, { vapidKey: VAPID })
    .then((cruKey) => {
      if (cruKey) {
        callback && callback(cruKey);
      } else {
        console.error("no curr key");
      }
    })
    .catch((e) => {
      console.warn(e);
    });
};

export const unsubscribe = () => {
  const messaging = getMessaging();
  return deleteToken(messaging);
};

export const isInitialized = () => { 
  return getApps().length !== 0;
}

export const handleFirebase = (
  onChangeCurKey: (token: string) => unknown,
  onNewMessage: (messagePayload: MessagePayload) => unknown,
  firebaseConfig: Record<string, string>,
  VAPID: string,
  refreshCurKey: boolean = true,
) => {
  if (getApps().length !== 0) return;

  const messaging = initialApp(firebaseConfig);

  function requestPermission() {
    return new Promise((resolve, reject) => {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          resolve(permission);
        } else {
          reject(permission);
        }
      });
    });
  }

  requestPermission().then(() => {
    refreshCurKey && getAppToken(messaging, onChangeCurKey, VAPID);
  });

  onMessage(messaging, (payload) => {
    onNewMessage(payload);
  });
};
